/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';

import type { Area } from 'types';

const find = async (): Promise<Area[]> => {
  const response = await callApiEndpoint('usermanagement/getUserAreas', {});
  return response.map(utils.toArea);
};

export default {
  find,
};
